export interface IMeta {
  data: IMetaData;
  getMetaColumn(columnName: string): IMetaColumn | undefined;
  enabledGridColumns: ComputedRef<IMetaColumn[]>;
  fieldGroups: ComputedRef<string[]>;
  enabledEditFormColumns: ComputedRef<IMetaColumn[]>;
  enabledCreateFormColumns: ComputedRef<IMetaColumn[]>;
  enabledDrilldowns: ComputedRef<IMetaForeignKey[]>;
  columns: IMetaColumn[];
  primaryKeyColumnNamePc: string;
}
export interface IMetaComputed {
  data: IMetaData;
  table: IMetaTable;
  // getMetaColumn(columnName: string): IMetaColumn | undefined | null;
  enabledGridColumns: IMetaColumn[];
  enabledGridColumnsMap: { [key: string]: IMetaColumn };
  fieldGroups: string[];
  enabledFilterColumns: IMetaColumn[];
  enabledFilterColumnsMap: { [key: string]: IMetaColumn };
  enabledEditFormColumns: IMetaColumn[];
  enabledEditFormColumnsMap: { [key: string]: IMetaColumn };
  enabledCreateFormColumns: IMetaColumn[];
  enabledCreateFormColumnsMap: { [key: string]: IMetaColumn };
  enabledCardColumns: IMetaColumn[];
  enabledCardColumnsMap: { [key: string]: IMetaColumn };
  columns: IMetaColumn[];
  columnsMap: { [key: string]: IMetaColumn };
  enabledDrilldowns: IMetaForeignKey[];
  enabledDrilldownsMap: { [key: string]: IMetaForeignKey };
  primaryKeyColumnNamePc: string;
}
export interface IMetaData {
  Table: IMetaTableWithPermissionsView;
  Columns: IMetaColumn[];
  FKeys: IMetaForeignKey[];
  Drilldowns: IMetaForeignKey[];
  PKeys: IMetaColumn[];
  Filters: any[];
  Actions: IMetaAction[];
}

export interface IRecord {
  Results: any[];
  Offset: number;
  Total: number;
  [key: string]: any;
}

export interface IOptions {
  query: any;
  skip: number;
  limit: number;
}

export interface IMetaTable {
  Id: number;
  TableCatalog: string;
  TableSchema: string;
  TableName: string;
  TableType: string;
  TableNamePc: string;
  TableNameUser: string;
  RecordsPerPage: number;
  FKTableName?: string;
  FKTableSchema?: string;
  MetaOperationId?: number;
  MetaOperationRoute?: string;
  IsEnabled: boolean;
  FriendlyUserUrl: string;
  RowVersionGuid: string;
  UpdateRecordEndpoint?: string;
  GetRecordEndpoint?: string;
  ShowOptions: boolean;
  NameColumn: string;
  UseColumnLayout?: boolean;
  ShowSelect: boolean;
  ShowCopy: boolean;
  ShowAdd: boolean;
  ShowEdit: boolean;
  ShowDelete: boolean;
  GroupBy?: string;
  ReadRecordsRoute?: string;
  EditRecordRoute?: string;
  SelectRecordRoute?: string;
  UpsertOn?: string;
  SoftDelete?: boolean;
  FilterQueryType?: string;
  OrderBy?: string[];
  ReportEndpointUrl?: string;
  ReportName?: string;
}

export interface IMetaTableWithPermissionsView extends IMetaTable {
  MetaVariationId?: number;
  RoleAuthId?: number;
  RoleAuthName?: string;
  MetaTablePermissionId?: number;
  Notes?: string;
}

export interface IMetaTableView {
  Id: number;
  TableCatalog: string;
  TableSchema: string;
  TableName: string;
  TableType: string;
  TableNamePc: string;
  TableNameUser: string;
  RecordsPerPage: number;
  FkTableName?: string;
  FkTableSchema?: string;
  MetaOperationId?: number;
  MetaOperationRoute: string;
  IsEnabled: boolean;
  FriendlyUserUrl: string;
  RowVersionGuid: string;
  UpdateRecordEndpoint: string;
  ShowOptions: boolean;
  NameColumn: string;
  UseColumnLayout?: boolean;
  ShowSelect: boolean;
  ShowCopy: boolean;
  ShowEdit: boolean;
  ShowDelete: boolean;
  GroupBy: string;
  GetRecordEndpoint: string;
  ShowAdd: boolean;
  ReadRecordsRoute: string;
  EditRecordRoute: string;
  SelectRecordRoute: string;
  UpsertOn: string;
  SoftDelete: boolean;
  OrderBy: string;
  Notes: string;
  FilterQueryType: string;
}

export interface IMetaColumn {
  Id: number;
  TenantId?: any;
  TableName: string;
  TableSchema: string;
  ColumnName: string;
  ColumnNamePc: string;
  ColumnAlias?: string;
  ControlType: string;
  FkEndpointName?: any;
  FkTableName?: string;
  FkTableSchema?: string;
  DisplayColumnName?: string;
  ValueColumnName?: string;
  DataType: string;
  ColumnLabel: string;
  Help?: string;
  Validation?: string | string[];
  OptionalValidation?: string | string[];
  IsEnabled: boolean;
  RowVersionGuid?: string;
  ShowInGrid: boolean;
  ShowInCreateForm: boolean;
  ShowInFilter: boolean;
  EndpointRoute?: string;
  Endpoint?: string;
  GridOrder: number;
  EditFormOrder: number;
  CreateFormOrder: number;
  FilterOrder: number;
  Placeholder?: string;
  MetaTableId?: number;
  IsIdentity: boolean;
  PrimaryKey: boolean;
  FilterDropdown: boolean;
  FilterRecordsPerPage: number;
  CacheDropdown: boolean;
  SearchType?: any;
  Mutable: boolean;
  CascadeFrom?: any;
  ShowExpression?: string;
  DisabledExpression?: string;
  DateFormat?: string;
  ShowInEditForm: boolean;
  FormSection?: string;
  FieldGroup?: string;
  ColSpanSm: number;
  ColSpanMd: number;
  ColSpanLg: number;
  ColSpanXl: number;
  ColSpanXxl: number;
  Column?: number;
  Computed: boolean;
  SelectSnippet?: string;
  MetaActionId?: number;
  ApplyCascadeOnLookupProperty?: string;
  IncludeInCopy?: boolean;
  SetFieldsAfterSelect?: string[];
  ShowAllOptionInSelect?: boolean;
  DefaultExpression?: string;
  ChangeCallback?: string;
  ChangeCallbackContextExpression?: string;
  RouteTo?: string;
  GridColumnWidth?: string;
  FilterControlType?: string;
  Notes?: string;
  ShowInCard?: boolean;
  CardOrder?: number;
  MultiSelectMappingTable?: string;
  MultiSelectMappingTableJoinColumn?: string;
  MultiSelectMappingTableForeignColumn?: string;
  BlurExpression?: string;
  GridColumnFrozen?: boolean;
  // Stuff from the view, but don't feel like dealing with ts
  TableCatalog?: string;
  CharacterMaximumLength?: number;
  IsNullable: string;
  OrdinalPosition: number;
  OnChangeComputationEndpoint?: string;
}

// export interface IMetaColumnView extends IMetaColumn {
//   TableCatalog: string;
//   CharacterMaximumLength: number;
//   IsNullable: string;
//   OrdinalPosition: number;
// }
export interface IMetaForeignKey {
  Id: number;
  TableCatalog: string;
  MetaTableId?: number;
  TableSchema: string;
  ConstraintName: string;
  TableName: string;
  TableNamePc: string;
  ColumnName: string;
  ColumnNamePc: string;
  ForeignTableSchema: string;
  ForeignTableName: string;
  ForeignColumnName: string;
  ForeignColumnNamePc: string;
  ConstraintType: string;
  ForeignTableNameUser: string;
  TableNameUser: string;
  ForeignTableNamePc: string;
  EditableInForeignKeyParent: boolean;
  NavigableFromForeignKeyParent: boolean;
  DisabledExpression?: string;
  ShowExpression?: string;
  Sequence: number;
  GetRecordsEndpoint?: string;
}

export interface IMetaAction {
  Id: number;
  Name: string;
  MetaTableId: number;
  TableSchema: any;
  ExecutionLocation: string;
  Method: RequestMethod;
  Route: string;
  Permisssion: any;
  ServerActionType: string;
  ContentType: string;
  Body: any;
  AuthenticationType: string;
  AuthenticationToken: any;
  AuthenticationActionId: any;
  AuthenticationActionResponseKey: any;
  ResponseContentType: string;
  PostActionResponse: string;
  PostActionResponseKey?: string;
  ResponseMessage?: string;
  GraphqlOperationName: any;
  SQLConnectionName: any;
  CacheResults: number;
  CacheDuration: number;
  CssClass: any;
  ButtonImageCss: any;
  SortOrder: number;
  DisabledExpression?: string;
  ShowExpression?: string;
  GridAction: number;
  CanExecute: boolean;
  UseConfirmationDialog?: boolean;
  ConfirmationHeaderText?: string;
  ConfirmationBodyText?: string;
  FilterQueryType?: string;
  ActionParameters?: IMetaActionParameter[];
  IsBulk: boolean;
  IsTopOfGrid: boolean;
}

import { InputType } from "./generic";
import type { RequestMethod } from "./interfaces";

export interface IMetaActionParameter {
  Id: number;
  ActionId: number;
  ActionParameterType: ActionParameterTypeEnum;
  Key: string;
  ActionParameterValueType: ActionParameterValueTypeEnum;
  Value: string;
  ControlType?: string;
  FieldLabel?: string;
  EndpointRoute?: string;
  DisplayKeyName?: string;
  ValueKeyName?: string;
  SortOrder?: number;
  Validation?: string[];
  ShowExpression?: string;
  CascadeFrom?: string;
}

export enum ActionParameterTypeEnum {
  Header = "Header",
  Authentication = "Authentication",
  Request = "Request",
  Url = "Url",
}

export enum ActionParameterValueTypeEnum {
  StaticValue = "StaticValue",
  DbValue = "DbValue",
  ActionResult = "ActionResult",
  ActionResultKey = "ActionResultKey",
  UserInput = "UserInput",
  QueryParameter = "QueryParameter",
  BulkFormParameter = "BulkFormParameter",
}

export enum IMetaControlTypesMapping {
  textarea = InputType.TextAreaInput,
  checkbox = InputType.BoolSelect,
  text = InputType.InputText,
  radio = InputType.RadioSelect,
  editor = InputType.RichText,
  multiselect = InputType.MultiSelect,
  time = InputType.TimeSelect,
  enumselect = InputType.EnumSelect,
  select = InputType.SelectDropdown,
  queryselect = InputType.SelectQuery,
  tableselect = InputType.SelectTable,
  textselect = InputType.SelectDropdown,
  fileuploadsingle = InputType.FileUpload,
  date = InputType.DateSelect,
  datetime = InputType.DateTimeSelect,
  number = InputType.NumberInput,
  integer = InputType.IntegerInput,
  percent = InputType.PercentageInput,
  currency = InputType.CurrencyInput,
  decimal = InputType.DecimalInput,
  default = InputType.InputText,
  picklist = InputType.PickList,
  daterange = InputType.DateRange,
  info = InputType.Info,
  year = InputType.YearSelect,
  month = InputType.MonthSelect,
  contractsummary = InputType.ContractSummary,
}

export interface IPostMetaAction {
  action: string;
  [key: string]: any;
}


export interface IFieldConfig {
  name: string;
  label: string;
  inputType: InputType;
  fieldGroup?: string;
  colSpan?: {
    sm: number;
    md: number;
    lg: number;
    xl: number;
    xxl: number;
  };
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  options?: { label: string; value: any }[];
  help?: string;

  // Validation options
  validation?: string | string[];
  optionalValidation?: string | string[];

  // Expression properties
  showExpression?: string;
  disabledExpression?: string;
  defaultExpression?: string;
  changeCallback?: string;

  // Lookup/dropdown configuration
  displayKey?: string;
  valueKey?: string;
  endpoint?: string;
  endpointId?: string;
  fkTableName?: string;
  fkSchemaName?: string;
  fetchOptions?: boolean;
  showAllOptionInSelect?: boolean;

  // Cascade configuration
  cascadeFrom?: string;
  applyCascadeOnLookupProperty?: string;

  // Additional field properties
  searchType?: string;
  affectFields?: string[];
  auxInputType?: string;
  min?: any;
  max?: any;
}

export interface IMetaMenu {
  Id: number;
  Link: string;
  Name: string;
  Icon?: string;
  SortOrder: number;
  MetaTableId?: number;
  MetaMenuPermissionId: number;
  MetaMenuVariationId: number;
  RoleAuthId: number;
  CanAccess: boolean;
  RoleName: string;
}